import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultDescription,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
  useRentPriceTypeCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentIndustrialPlotRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  objectNumbers: defaultObjectNumbers,
  basicInfo: {
    plotArea: validationRules.plotArea,
    separableSpace: validationRules.separableSpace,
    usageType: validationRules.usageType,
    price: useRentPriceTypeCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: defaultDescription,
  otherFacilities: {
    gfz: validationRules.gfzField,
    grz: validationRules.grzField,
  },
  apiSearchData: defaultApiSearchData,
}
